export class HTTPError extends Error {
  constructor(public response: Response) {
    super();
    this.name = 'HTTPError';
    this.message = `${this.name}: ${response.status} ${response.statusText}`;
    // Surface the response object for downstream handling, if some custom catch logic is needed
    this.response = response;
  }
}
